import { Box } from '@material-ui/core';
import { CheckoutSession, formatDateTimeReadable } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { RefreshIconButton } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/RefreshIconButton';
import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { useLiveCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useLiveCheckoutSession';
import { CheckoutSessionActions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/CheckoutSessionActions';
import { CheckoutSessionPaymentMethodEditActions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/CheckoutSessionPaymentMethodEditActions';
import { LiveIndicator } from '@/components/shared/components/LiveIndicator';
import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface CheckoutSessionHeaderProps {
  checkoutSession: CheckoutSession;
}

export const CheckoutSessionHeader = ({ checkoutSession }: CheckoutSessionHeaderProps) => {
  const { sm } = useScreen();

  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();
  const { state: liveState } = useLiveCheckoutSession(checkoutSession.id);

  const [isLoading, setIsLoading] = useState(false);

  const onRefresh = async () => {
    try {
      setIsLoading(true);
      await refreshCheckoutSessionAndPaymentMethodEntities();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Section>
      <Box overflow={'hidden'} display={'flex'} alignItems="flex-start" justifyContent={'space-between'} gridGap={24}>
        {sm && (
          <Box display={'flex'} flexDirection={'column'} minWidth={0}>
            <OverviewDetailRow field={<Text tId={'CHECKOUT_SESSION_ID'} />} value={checkoutSession.id} copyButton />
            <OverviewDetailRow
              field={<Text tId={'CREATED_AT'} />}
              value={formatDateTimeReadable(checkoutSession.createdAt)}
            />
          </Box>
        )}
        <Box
          flexShrink={0}
          width={sm ? 'auto' : '100%'}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-end'}
          gridGap={4}
        >
          <LiveIndicator state={liveState} />
          <RefreshIconButton onClick={onRefresh} />
          <CheckoutSessionPaymentMethodEditActions disabled={isLoading} color="default" />
          <CheckoutSessionActions disabled={isLoading} color="default" />
        </Box>
      </Box>
    </Section>
  );
};
